module.exports = __webpack_public_path__ + "img/custom-pin-sel.cf85a1b1.svg";